export default __webpack_public_path__ + "img/add-attachment.694ba497.svg";